<template>
  <div class="diagnostic d-inline-flex flex-column overflow-auto">
    <div>
      <div class="diagnostic__title">
        <strong>{{ $t('general.diagnostic') }}</strong>
      </div>
      <template v-if="data.diagnostics.length">
        <p
          v-for="(diagnostic, index) in diagnostics"
          :key="index"
        >
          <classification
            :classification="diagnostic.classification"
            show-label
            show-tooltip
          />
          {{ diagnostic.description }}
        </p>
      </template>
      <span v-else-if="emptyDiagnosisIsNormal" class="text-green">
        {{ $t('engineering.normal') }}
      </span>
      <span v-else> {{ $t('engineering.not-exceed-minimum') }} </span>
    </div>
    <div v-if="alarmed && data.recommendations.length">
      <div class="mt-2">
        <strong>{{ $t('general.recommendations') }}</strong>
      </div>
      <p v-for="recommendation in recommendations" :key="recommendation">
        {{ recommendation }}
      </p>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.diagnostic
  max-height: 13rem
  +media-min-md()
    width: 50%
  &__title
    margin-bottom: 1rem
</style>

<script>
import Classification from '@/components/Classification';

export default {
  components: { Classification },
  props: {
    data: {
      type: Object,
      required: true,
    },
    alarmed: {
      type: Boolean,
      default: false,
    },
    emptyDiagnosisIsNormal: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    recommendations() {
      return this.data.recommendations || [];
    },
    diagnostics() {
      return this.data.diagnostics || [];
    },
  },
};
</script>
